var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNginxLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 115.11875 24.187275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.56225 -11.12422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m14.047838 32.727592v-19.064695l19.062499 19.064695v-19.064695",
    fill: "none",
    stroke: "#090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.6875 11.1875-.6875 1.28125-5.3125 9.65625-.6875 1.21875.6875 1.21875 5.3125 9.34375.71875 1.28125h1.46875 10.875 1.5625l.6875-1.40625 3.96875-8 1.78125-3.625h-4.03125l-10.15625.03125c-1.320782-.01868-2.535605 1.179086-2.535605 2.5s1.214823 2.518679 2.535605 2.5l6.125-.03125-1.5 3.03125h-7.875l-3.90625-6.875 3.9375-7.125h8.377221l1.953125 4.007812h5.03125l-3.171875-7.601562-.6875-1.40625h-1.5625-11.408471z",
    fill: "#090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.013782 11.15625c-1.308989.01639-2.485084 1.222261-2.46875 2.53125v6.514509h5v-6.514509c.01659-1.329821-1.201429-2.547843-2.53125-2.53125z",
    fill: "#090"
  }), /*#__PURE__*/React.createElement("use", {
    height: 1052.3622,
    transform: "matrix(-1 0 0 1 111.13905 .04841623)",
    width: 744.09448,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.10586251 .33010228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m104.90935 13.374209 19.08481 19.017856",
    fill: "none",
    stroke: "#090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("use", {
    height: 1052.3622,
    transform: "matrix(-1 0 0 1 228.92583 0)",
    width: 744.09448,
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m70.013782 35.204069c-1.308989-.01639-2.485084-1.222261-2.46875-2.53125v-10.464363h5v10.464363c.01659 1.329821-1.201429 2.547843-2.53125 2.53125z",
    fill: "#090"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNginxLogo);
export default __webpack_public_path__ + "static/media/Nginx_logo.82332f93e7454e979437e69cab2ee6af.svg";
export { ForwardRef as ReactComponent };